var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.698,
    height: 41.816,
    viewBox: "0 0 52.698 41.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(39.089 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36563",
    "data-name": "Trac\\xE9 36563",
    d: "M7.852,6H46.668a4.866,4.866,0,0,1,4.852,4.852V39.964a4.866,4.866,0,0,1-4.852,4.852H7.852A4.866,4.866,0,0,1,3,39.964V10.852A4.866,4.866,0,0,1,7.852,6Z",
    transform: "translate(-40)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36564",
    "data-name": "Trac\\xE9 36564",
    d: "M51.52,9,27.26,25.982,3,9",
    transform: "translate(-40 1.852)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.58607037b7cdb9246361d18503c80207.svg";
export { ForwardRef as ReactComponent };